import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../../../layout/theme-next/provider';

export const styles = makeStyles<NextTheme>((theme) => ({
  input: {
    '&.MuiInputBase-root': {
      marginTop: 10,
      padding: 0,
    },
    '& .MuiInputBase-input': {
      padding: 10,
      fontSize: 14,
    },
  },
  renderHtmlRoot: {
    marginBottom: theme.spacing(-2.5),
  },
}));
